/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import MarginModal from './InformationModals/MarginModal';
import OptionsModal from './InformationModals/OptionsModal';
import RestrictedMarginModal from './InformationModals/RestrictedMarginModal';
import RestrictedMarginTseuModal from './InformationModals/RestrictedMarginTseuModal';
import Config from '../../Config';

const config = new Config();

const MarginAndOptionsSettings = (props) => {
  const {
    canTradeOptions,
    canTradeMargin,
    handleTradeStockOptionsChange,
    isMarginRestricted,
    isTseu,
  } = props;

  const [isMarginModalOpen, setMarginModalOpen] = useState(false);
  const [isOptionsModalOpen, setOptionsModalOpen] = useState(false);
  const [isMarginRestrictedMarginModalOpen, setMarginRestrictedMarginModalOpen] = useState(false);

  const toggleMarginModal = () => {
    setMarginModalOpen(!isMarginModalOpen);
  };

  const toggleOptionsModal = () => {
    setOptionsModalOpen(!isOptionsModalOpen);
  };

  const openMarginRestrictedMarginModal = () => {
    setMarginRestrictedMarginModalOpen(true);
  };

  const handleRestrictedMarginModalClose = () => {
    setMarginRestrictedMarginModalOpen(false);
  };

  const LINK_CLASS_NAME_MARGIN =
    `btn btn-img checkbox btn-img-auto form-group col-xs-12 LINKCLASSNAME ${!canTradeMargin ? 'disabled' : ''}`;

  const LINK_CLASS_NAME_OPTIONS =
    `btn btn-img checkbox btn-img-auto form-group col-xs-12 LINKCLASSNAME ${!canTradeOptions ? 'disabled' : ''}`;

  return (
    <div className="col col-sm-6 col-xs-12">
      <div className="row">
        <div className="panel-equities-left">
          <h1 className="h2_subHeading equities-account-settings-header">
            Trading Permissions
          </h1>
          <div className="full-width-border" />
          <div className="displayFlex">
            <a
              href="#"
              className={`${LINK_CLASS_NAME_MARGIN} ${!canTradeMargin || isMarginRestricted ? 'margin-disabled' : ''}`}
            >
              <label className="row" htmlFor="marginAccount">
                <Field
                  data-toggle="modal"
                  name="marginAccount"
                  id={'marginAccount'}
                  component="input"
                  type="checkbox"
                  value="marginAccount"
                  disabled={!canTradeMargin || isMarginRestricted}
                />
                <div className="col">
                  <div className="col col-md-12">
                    <div className="btn-label">Margin Trading</div>
                  </div>
                </div>
              </label>
            </a>
            <button
              type="button"
              className="tradingHelpButton"
              onClick={toggleMarginModal}
            >
              <i className="material-icons title-help">help</i>
            </button>
          </div>
          {isMarginRestricted &&
            <div className="margin-disabled-modal-button-div">
              <button
                type="button"
                onClick={openMarginRestrictedMarginModal}
                className="margin-disabled-modal-button"
              >
                Why is this disabled?
              </button>
            </div>
          }
          <br />
          <div className="displayFlex">
            <a href="#" className={LINK_CLASS_NAME_OPTIONS}>
              <label className="row" htmlFor="tradeStockOptions">
                <Field
                  data-toggle="modal"
                  name="tradeStockOptions"
                  id={'tradeStockOptions'}
                  component="input"
                  type="checkbox"
                  value="tradeStockOptions"
                  onChange={handleTradeStockOptionsChange}
                  disabled={!canTradeOptions ? 'disabled' : ''}
                />
                <div className="col">
                  <div className="col col-md-12">
                    <div className="btn-label">Options Trading</div>
                  </div>
                </div>
              </label>
            </a>
            <button
              type="button"
              className="tradingHelpButton"
              onClick={toggleOptionsModal}
            >
              <i className="material-icons title-help">help</i>
            </button>
          </div>
          <br />
        </div>
      </div>
      {isMarginModalOpen && <MarginModal onClose={toggleMarginModal} />}
      {isOptionsModalOpen && <OptionsModal onClose={toggleOptionsModal} />}
      {isMarginRestrictedMarginModalOpen && (!config.tseuChangesEnabled || (config.tseuChangesEnabled && !isTseu)) && (
        <RestrictedMarginModal {...props} onClose={handleRestrictedMarginModalClose} />
      )}
      {isMarginRestrictedMarginModalOpen && config.tseuChangesEnabled && isTseu && (
        <RestrictedMarginTseuModal {...props} onClose={handleRestrictedMarginModalClose} />
      )}
    </div>
  );
};

MarginAndOptionsSettings.propTypes = {
  canTradeOptions: PropTypes.bool,
  canTradeMargin: PropTypes.bool,
  handleTradeStockOptionsChange: PropTypes.func,
  isMarginRestricted: PropTypes.bool,
  isTseu: PropTypes.bool.isRequired,
};

export default MarginAndOptionsSettings;
